<script setup lang="ts">
/** POST /knowledge-bases · name, language (text search config), chunk target 128–2048 tokens, overlap 0–50 %. */
import Dialog from '~/components/ui/Dialog.vue'
import Field from '~/components/ui/Field.vue'
import SelectField from '~/components/ui/SelectField.vue'
import Icon from '~/components/ui/Icon.vue'
import ActionButton from '~/components/ui/ActionButton.vue'

defineEmits<{ close: []; submit: [payload: Record<string, unknown>] }>()
const name = ref('')
const language = ref('simple')
const target = ref('512')
const overlap = ref('15')
const languages = [
  { value: 'simple', label: 'Any language' }, { value: 'english', label: 'English' }, { value: 'german', label: 'German' },
  { value: 'french', label: 'French' }, { value: 'spanish', label: 'Spanish' }, { value: 'russian', label: 'Russian' },
]
const issue = computed(() => {
  const t = Number(target.value), o = Number(overlap.value)
  if (t < 128 || t > 2048) return 'Chunk must be 128 to 2 048 tokens'
  if (o < 0 || o > 50) return 'Overlap must be 0 to 50 percent'
  return ''
})
</script>

<template>
  <Dialog title="New memory collection" meta="indexed for grounded answers" :width="480" @close="$emit('close')">
    <template #icon><Icon name="memory" /></template>
    <Field v-model="name" label="Name" placeholder="product-docs" hint="Up to 120 characters · shown in Playground and Deploy" />
    <SelectField v-model="language" label="Language" :options="languages" hint="Tunes search for the language of the documents" />
    <div class="grid grid-cols-2 gap-3">
      <Field v-model="target" label="Chunk size" type="number" hint="tokens · 128 to 2 048 · default 512" :error="issue.startsWith('Chunk') ? issue : ''" />
      <Field v-model="overlap" label="Overlap" type="number" hint="percent · 0 to 50 · default 15" :error="issue.startsWith('Overlap') ? issue : ''" />
    </div>
    <template #actions>
      <ActionButton label="Cancel" @click="$emit('close')" />
      <ActionButton label="Create collection" variant="primary" :disabled="!name || !!issue" @click="$emit('submit', { name: name.trim(), textSearchConfig: language, chunkConfig: { targetTokens: Number(target), overlapPct: Number(overlap) / 100 } })"><template #icon><Icon name="plus" /></template></ActionButton>
    </template>
  </Dialog>
</template>
